module.exports = __webpack_public_path__ + "img/KSAT25-45-1000-2-complete.d05a67ce.png";